/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OrdersInputs */

const en_nav_orders = /** @type {(inputs: Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_nav_orders = /** @type {(inputs: Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Nav_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_orders = /** @type {((inputs?: Nav_OrdersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OrdersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_orders(inputs)
	return es_nav_orders(inputs)
});